import React, { useEffect, useRef, useState } from 'react'
import clsx from 'clsx'

// Portal edition: same page frame as the LeaRes webapp Layout, without the
// in-app Menubar (the portal has no application menus).
const Layout = ({ children }) => {
  const [windowRatio, setWindowRatio] = useState(
    window.innerWidth / window.innerHeight
  )

  const isListenerAdded = useRef(false)

  useEffect(() => {
    if (isListenerAdded.current) return
    isListenerAdded.current = true

    const handleResize = () => {
      setWindowRatio(window.innerWidth / window.innerHeight)
    }
    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
      isListenerAdded.current = false
    }
  }, [])

  return (
    <div
      className={clsx(
        'p-[4px] desktop:p-[6px] my-0 mx-auto h-full w-full box-border',
        {
          'max-w-[1920px]': windowRatio > 2,
        }
      )}
    >
      {children}
    </div>
  )
}

export default Layout
